import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default {
    namespaced: true,
    state: {
        items: [],
        brands: [],
        searchTerm: "",
        brandCounts: {},
        groupedItems: {},
    },
    mutations: {
        setSearchTerm: function(state, searchTerm){
            state.searchTerm = searchTerm;
        },
        clearList: function(state){
            state.items = [];
            state.groupedItems = {};
        },
        addSparesToList: function(state, spares){
            spares.forEach(function(item){
                state.items.push(item);
            });
        },
        groupList: function(state){

            let term = state.searchTerm;

            state.items = state.items.sort(function(l, r) {

                let leq = (l.stripped.toUpperCase() === term.toUpperCase());
                let req = (r.stripped.toUpperCase() === term.toUpperCase());

                if (leq !== req) {
                    if (leq) {return -1}
                    if (req) {return  1}
                }

                let lp = parseFloat(l.price);
                let rp = parseFloat(r.price);

                if (lp === rp) {return  0;}
                if (lp  <  rp) {return -1;}

                return 1;
            });

            let groupedItems = {};
            let brandCounts = {};
            let grouped = {};
            let brands = [];

            state.items.forEach(function(item){

                if (brands.indexOf(item.manufacturer) === -1) {
                    brands.push(item.manufacturer);
                    brandCounts[item.manufacturer] = 0;
                }
                brandCounts[item.manufacturer]++;

                if ( ! grouped[item.id]) {
                    grouped[item.id] = [];
                }
                grouped[item.id].push(item);
            });

            for (const id in grouped) {
                const items = grouped[id];
                if (items.length > 0) {
                    let optimal = Object.assign({}, items[0]);
                    let sources = {};
                    items.forEach(function(item){
                        if (parseFloat(item.price) < parseFloat(optimal.price)) {
                            optimal = item;
                        }
                        sources[item.source] = item.source;
                    });
                    optimal.sources = sources;
                    optimal.identical = items;
                    optimal.identicalCount = items.length;
                    groupedItems[id] = optimal;
                }
            }
            state.groupedItems = groupedItems;
            state.brands = brands.sort();
            state.brandCounts = brandCounts;
        },
    },
    actions: {
        setSearchTerm: function(context, searchTerm) {
            context.commit('setSearchTerm', searchTerm);
        },
    },
    getters: {
        brands: function(state){
            return state.brands;
        },
        brandCounts: function(state){
            return state.brandCounts;
        },
        items: function(state){
            return state.groupedItems;
        },
        count: function(state){
            return state.items.length;
        },
    },
};